const flow = require('lodash/fp/flow');
const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');

function getQS(parsedMetaData) {
  return {
    pfRelId: parsedMetaData.portfolio.pfRelId,
    branchCode: parsedMetaData.portfolio.branchCode,
  };
}

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    Accept: 'application/json',
  };
  const reqOpts = { headers, method: 'POST', json: true };

  const requestArray = flow(
    requestHandler,
    x => x.catch(e => {
      if (e.statusCode === 404) return [];
      throw e;
    })
  );

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getAssetList(portfolioId, asset, metaData) {
      const url = getUrl('asset-market-value');
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        pfRelId: parsedMetaData.portfolio.pfRelId, 
        branchCode: parsedMetaData.portfolio.branchCode,
        destinationCurrency: parsedMetaData.qs.destinationCurrency
      };

      return requestArray(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },
  };
}

module.exports = apiFactory;
